import { Translation, QRType } from '../types';

export const ko: Translation = {
  nav: {
    generator: '생성기',
    scanner: '스캐너',
    mobile: '모바일에서 사용해보기',
    blog: '블로그',
    langSelect: '언어 선택',
  },
  pageTitles: {
    generator: '무료 온라인 QR 코드 생성기',
    scanner: '온라인 QR 코드 스캐너',
    textToQr: '텍스트 → QR 코드 변환기',
    linkToQr: '링크 → QR 코드 생성기',
  },
  pageMeta: {
    generator: {
      title:
        '무료 QR 코드 생성기 — 온라인에서 QR 코드 만들기 (가입/워터마크 없음, PNG/SVG/PDF) | YesQRCode',
      description:
        'YesQRCode로 무료로 QR 코드를 온라인에서 생성하세요. URL, 텍스트, Wi‑Fi, vCard 등 다양한 형식을 지원합니다. 고품질 PNG, SVG, PDF로 다운로드. 가입/로그인/워터마크 없이 빠르고 안전하게, 영구 무료.',
      keywords: [
        'qr 코드 생성기',
        '무료 qr 코드 생성기',
        '온라인 qr 코드 만들기',
        'qr 코드 메이커',
        'qr 코드 png',
        'qr 코드 svg',
        'qr 코드 pdf',
        'wifi qr 코드 생성기',
        'vcard qr 코드 생성기',
        '가입 없는 qr 생성기',
      ],
    },
    scanner: {
      title:
        '온라인 QR 코드 스캐너 — 이미지/카메라로 스캔 (안전, 가입 없음) | YesQRCode',
      description:
        'QR 코드와 바코드를 무료로 온라인에서 스캔하세요. 이미지를 업로드하거나 카메라를 사용할 수 있습니다. 모든 처리는 로컬에서 이루어지며 업로드가 없습니다. 안전하고 빠르며 가입/로그인 없이 무료로 사용 가능합니다.',
      keywords: [
        'qr 코드 스캐너',
        '온라인 qr 스캔',
        '온라인 qr 리더',
        '이미지에서 qr 스캔',
        '온라인 바코드 스캔',
        '보안 qr 스캐너',
        '업로드 없는 qr 스캐너',
        '무료 qr 스캐너',
        '브라우저 qr 스캐너',
        '가입 없는 qr 스캐너',
      ],
    },
    textToQr: {
      title: '텍스트를 QR로 | 메모를 QR 코드로 변환',
      description:
        '텍스트 조각, 메모, 메시지를 공유 가능한 QR 코드로 변환하세요. 브랜딩을 적용하고 PNG, SVG, PDF로 즉시 내보낼 수 있으며, 등록이 필요 없습니다.',
      keywords: ['텍스트 qr', '텍스트 qr 생성기', '메모 qr 코드', '메시지 qr', '온라인 qr 변환', '무료 텍스트 qr'],
    },
    linkToQr: {
      title: '링크를 QR로 | URL을 QR 코드로 변환',
      description:
        '웹사이트나 캠페인 URL을 붙여 넣고 즉시 인쇄/디지털용 QR 코드를 생성하세요. 사용자 지정 색상, 로고, 고해상도 다운로드를 지원합니다.',
      keywords: ['링크 qr', 'url qr 생성기', '웹사이트 qr', '링크용 qr', 'utm qr 코드', 'qr pdf 다운로드'],
    },
  },
  hero: {
    title: '개인정보 보호·브랜드 최적화 QR 코드 — 영구 무료.',
    subtitle: '빠르고, 프라이빗하며, 어떤 워크플로에도 맞는 QR 도구.',
    desc: '계정/워터마크/데이터 업로드 없이 고품질 QR 코드를 생성하고 스캔하세요.',
    ctaPrimary: 'QR 코드 생성',
    ctaSecondary: '모바일에서 사용해보기',
  },
  info: {
    helpTitle: '도움말 센터',
    helpSubtitle: '자주 묻는 질문 & 지원',
    contactTitle: '문의하기',
    contactSubtitle: '의견을 들려주세요.',
    privacyTitle: '개인정보 처리방침',
    termsTitle: '서비스 이용약관',
  },
  contactForm: {
    name: '이름',
    email: '이메일',
    message: '메시지',
    send: '메시지 보내기',
    orEmail: '또는 아래 주소로 직접 이메일을 보내세요',
    sending: '전송 중...',
    successTitle: '전송 완료!',
    successMessage: '문의해 주셔서 감사합니다. 곧 답변드리겠습니다.',
    sendAnother: '다른 메시지 보내기',
    errorMessage: '지금은 메시지를 보낼 수 없습니다. support@yesqrcode.com으로 이메일을 보내주세요.',
  },
  generator: {
    highlights: {
      title: '개인정보 보호·브랜드 최적화 QR 코드 — 영구 무료.',
      subtitle: '빠르고, 프라이빗하며, 어떤 워크플로에도 맞는 QR 도구.',
      items: [
        {
          title: '프라이버시 우선, 기기 내 생성',
          desc: 'QR 코드는 로컬에서 생성됩니다 — 업로드/추적/데이터 저장 없음.',
        },
        {
          title: '모든 사용 사례를 위한 풍부한 기능',
          desc: 'URL, Wi‑Fi, vCard, 바코드, 로고, 그라디언트, 프레임 — 모두 내장.',
        },
        {
          title: '모바일 친화적, 누구나 쉽게',
          desc: '휴대폰과 터치 인터랙션에 최적화되어 생성/스캔이 부드럽습니다.',
        },
        {
          title: '영구 무료, 상업적 사용 가능',
          desc: '계정/워터마크/스캔 제한 없음 — 팀과 비즈니스에 안정적.',
        },
      ],
    },
    featureSuite: {
      title: '개인정보 보호 중심의 완전한 QR 스위트',
      subtitle: '깨끗하고, 브랜드에 맞고, 고품질 QR 코드를 만들기 위한 모든 것 — 한 곳에서.',
      categories: [
        {
          title: '필요한 모든 QR 코드 유형',
          body: 'URL, 텍스트, Wi‑Fi, 이메일, 전화, SMS, vCard, 소셜 링크, YouTube, 바코드. 만료되지 않는 정적 코드.',
          items: [],
        },
        {
          title: '브랜딩 & 디자인',
          body: '로고를 넣어도 안전한 코드, 그라디언트, 프레임, 모양/코너, 스캔 최적화 레이아웃.',
          items: [],
        },
        {
          title: '출력 & 품질',
          body: '인쇄/디지털 프리셋과 함께 고품질 PNG, SVG, PDF로 내보내기.',
          items: [],
        },
        {
          title: '글로벌 & 사용성',
          body: '다국어 UI, 모바일 우선 디자인, 오프라인 친화적 워크플로.',
          items: [],
        },
      ],
    },
    trust: {
      title: '크리에이터·팀·브랜드가 신뢰하는 도구',
      subtitle:
        'YesQRCode는 가볍고 예측 가능하며 장기 캠페인에 안전하도록 설계되었습니다 — 계정 없이, 벤더 락인 없이, 숨은 제한 없이.',
      items: ['온보딩 없음', '예측 가능한 정적 코드', '기업 안전: 클라우드 처리 없음', '모든 자산에서 일관된 브랜딩'],
    },
    sectionContent: '콘텐츠',
    sectionColors: '색상',
    sectionLogo: '로고',
    sectionFrame: '프레임',
    sectionDesign: '디자인',
    sectionCorrection: '오류 수정',
    labelUrl: '웹사이트 URL',
    labelText: '일반 텍스트',
    labelSsid: '네트워크 이름(SSID)',
    labelPassword: '비밀번호',
    labelEncryption: '암호화',
    labelFgColor: '전경색',
    labelBgColor: '배경색',
    labelFrameText: '프레임 문구',
    labelFrameColor: '프레임 색상',
    placeholder: '여기에 내용을 입력하세요...',
    placeholders: {
      url: 'https://example.com',
      text: '여기에 텍스트 입력',
      email: 'you@email.com',
      subject: '제목',
      message: '메시지...',
      phone: '+82 10-1234-5678',
      ssid: 'MyWiFi',
      password: '***',
      barcode: '123456789012',
    },
    download: 'PNG 다운로드',
    downloadSvg: 'SVG 다운로드',
    generateButton: 'QR 코드 생성',
    copy: 'SVG 복사',
    uploadLogo: '이미지 업로드',
    preview: '미리보기',
    lowQuality: '낮은 품질',
    highQuality: '높은 품질',
    foreverFree: '영구 무료 • 가입 없음 • 상업적 사용',
    barcodeWarning: '바코드에서는 프레임/로고 같은 고급 디자인 옵션을 사용할 수 없습니다.',
    barcodeColors: '대신 아래에서 색상은 사용자 지정할 수 있습니다.',
    frameStyles: {
      none: '없음',
      simple: '심플',
      balloon: '말풍선',
      box: '박스',
      badge: '배지',
      polaroid: '폴라로이드',
      phone: '폰',
      header: '헤더',
      corner: '코너',
    },
    vCard: {
      firstName: '이름',
      lastName: '성',
      mobile: '휴대폰',
      phone: '전화',
      fax: '팩스',
      email: '이메일',
      company: '회사',
      job: '직함',
      street: '주소',
      city: '도시',
      zip: '우편번호',
      state: '주/도',
      country: '국가',
      website: '웹사이트',
    },
    types: {
      [QRType.URL]: 'URL',
      [QRType.TEXT]: '텍스트',
      [QRType.EMAIL]: '이메일',
      [QRType.PHONE]: '전화',
      [QRType.SMS]: 'SMS',
      [QRType.WIFI]: 'Wi‑Fi',
      [QRType.VCARD]: 'vCard',
      [QRType.FACEBOOK]: 'Facebook',
      [QRType.TWITTER]: 'X (Twitter)',
      [QRType.YOUTUBE]: 'YouTube',
      [QRType.BARCODE]: '바코드',
    },
    guide: {
      title: '맞춤형 QR 코드는 어떻게 만들까요?',
      steps: [],
    },
    gettingStarted: {
      title: '사용 방법',
      steps: [
        {
          title: 'QR 콘텐츠 설정',
          text: '상단에서 콘텐츠 유형(URL, 텍스트, 이메일...)을 선택하세요. 유형을 선택하면 사용 가능한 옵션이 표시됩니다. 스캔 시 표시될 모든 값을 입력하세요. 인쇄 후에는 콘텐츠를 변경할 수 없으니 정확히 입력했는지 확인하세요.',
        },
        {
          title: '디자인 커스터마이즈',
          text: 'QR 코드를 더 특별하게 만들고 싶나요? 색상을 바꾸고 기본 모양을 교체해 보세요. 코너와 본문은 각각 개별 설정이 가능합니다. 갤러리에서 로고를 선택하거나 직접 로고 이미지를 업로드해 추가하세요.',
        },
        {
          title: 'QR 코드 생성',
          text: '슬라이더로 픽셀 해상도를 조정하세요. “다운로드” 버튼을 눌러 저장합니다. 미리보기를 스캐너로 읽어 정상 동작을 확인하세요. 인쇄 품질의 PNG가 필요하면 높은 해상도를 사용하세요.',
        },
        {
          title: '이미지 다운로드',
          text: '이제 .png, .svg, .pdf로 QR 코드를 다운로드할 수 있습니다. 전체 디자인을 포함한 벡터 형식이 필요하면 .svg를 선택하세요. SVG는 Adobe Illustrator나 Inkscape 같은 소프트웨어에서 사용할 수 있습니다. 로고/디자인 설정은 현재 .png와 .svg에서만 동작합니다.',
        },
      ],
    },
    about: {
      title: '무료, 개인정보 보호 중심 QR 스위트',
      subtitle:
        '계정/워터마크/데이터 업로드 없이 고품질 QR 코드를 생성하고 스캔하세요. 인쇄, 브랜딩, 상업적 사용에 최적화되어 있습니다.',
      features: [
        'URL, 텍스트, Wi‑Fi, vCard, SMS, 바코드 등 인기 유형 지원',
        '최대 30% 오류 수정으로 로고에도 안전',
        '사용자 지정 모양, 그라디언트, 색상, 프레임',
        '만료되지 않는 정적 QR 코드',
        '글로벌 팀을 위한 다국어 UI',
      ],
      content: [
        {
          title: '로고에 안전한 QR 코드',
          body: '스캔 실패 걱정 없이 로고를 추가하세요. 최대 30% 오류 수정으로 패키지, 메뉴, 안내판 등에서도 가독성을 유지합니다.',
        },
        {
          title: '사용자 지정 모양과 프레임',
          body: '코너 모양을 바꾸고 그라디언트를 적용하며 캠페인에 맞는 프레임을 선택하세요. 디자인 중심의 제어로 브랜드 느낌을 살리면서도 스캔 가능성을 유지합니다.',
        },
        {
          title: '다양한 콘텐츠 유형',
          body: 'URL, 텍스트, Wi‑Fi, vCard, SMS, 바코드를 한 곳에서 생성하고, 형식별 프리셋으로 설정을 쉽게 합니다.',
        },
        {
          title: '오래가는 정적 코드',
          body: '만료되거나 스캔이 제한되지 않는 정적 QR 코드를 만들어 장기 캠페인과 인쇄물에 적합합니다.',
        },
      ],
    },
    faq: {
      title: '자주 묻는 질문',
      items: [
        {
          q: 'QR 코드는 무엇인가요?',
          a: 'QR은 Quick Response Code의 약자이며, 1994년 Denso Wave가 발명한 바코드의 한 종류입니다.',
        },
        {
          q: '생성한 QR 코드를 상업적으로 사용해도 되나요?',
          a: '네. 이 생성기로 만든 QR 코드는 모두 무료이며 원하는 용도로 사용할 수 있습니다.',
        },
        {
          q: '생성된 QR 코드는 만료되나요?',
          a: '만료되지 않으며 영구적으로 작동합니다! YesQRCode로 만든 QR 코드는 정적(static)이며 일정 시간이 지나도 멈추지 않습니다. 다만 생성 후에는 내용을 다시 편집할 수 없습니다.',
        },
        {
          q: 'QR 코드에 스캔 횟수 제한이 있나요?',
          a: '제한이 없습니다. 생성된 QR 코드는 영구적으로 동작하며 원하는 만큼 스캔할 수 있습니다!',
        },
        {
          q: 'YesQRCode가 내 데이터를 저장하나요?',
          a: '저희는 어떤 형태로도 데이터를 저장하거나 재사용하지 않습니다. 성능 최적화를 위해 QR 코드 이미지 파일을 서버에 24시간 캐시할 수 있습니다.',
        },
        {
          q: 'vCard QR 코드가 올바른 필드를 표시하지 않아요.',
          a: '일부 스캐너는 공식 vCard 표준을 완전히 따르지 않아 연락처 필드가 섞일 수 있습니다. 더 나은 결과를 위해 다른 스캐너 앱을 사용해 보세요.',
        },
        {
          q: 'QR 코드가 작동하지 않으면 어떻게 하나요?',
          a: '원인은 다양합니다. 먼저 입력 데이터를 확인하세요. URL의 작은 오타가 문제를 일으킬 수 있습니다. vCard처럼 데이터가 많은 경우 가능한 한 줄여 보세요. 로고를 제거해 보고, 배경/전경 대비가 충분한지도 확인하세요. 전경은 항상 배경보다 더 어두워야 합니다.',
        },
        {
          q: 'YesQRCode는 모든 브라우저에서 동작하나요?',
          a: 'YesQRCode는 최신 HTML5 지원 브라우저가 필요하며, Chrome, Firefox, Safari, Edge, Internet Explorer 11을 공식 지원합니다.',
        },
      ],
    },
  },
  scanner: {
    title: 'QR & 바코드 스캔',
    subtitle: '카메라, 이미지 업로드, 또는 붙여넣기로 QR/바코드를 즉시 디코딩하세요.',
    cameraPermission: '카메라 접근이 거부되었습니다. 브라우저 설정에서 권한을 허용하세요.',
    result: '결과',
    copy: '복사',
    copied: '복사됨',
    open: '링크 열기',
    delete: '삭제',
    scanAgain: '다시 스캔',
    privacy: '처리는 브라우저에서 로컬로 진행됩니다. 파일은 기기를 떠나지 않습니다.',
    upload: '이미지 업로드',
    paste: '붙여넣기 (Ctrl+V)',
    drop: '여기에 이미지를 드롭하세요',
    retry: '다시 시도',
    errorAccessDenied: '카메라 접근 거부',
    errorCamera: '브라우저 설정에서 카메라 접근을 허용해 주세요.',
    initializing: '카메라 초기화 중...',
    cameraActive: '카메라 활성화',
    scannedItems: '스캔 항목',
    recentScans: '최근(로컬 저장)',
    clickToUpload: '클릭하여 업로드',
    newBadge: 'NEW',
    tabCameraMobile: '카메라',
    tabCameraDesktop: '카메라로 스캔',
    emptyState: {
      title: '아직 스캔한 항목이 없습니다',
      desc: '이미지를 업로드하거나 카메라 탭을 사용해 시작하세요.',
    },
    highlights: {
      title: '빠르고 프라이빗한 스캔',
      items: [
        { title: '기기 내 디코딩', desc: '기본적으로 업로드가 없어서 민감한 URL/자산에도 안전합니다.' },
        { title: '다양한 형식', desc: 'QR뿐 아니라 UPC/EAN, Code 128, ITF 등도 지원합니다.' },
        { title: '빠른 작업', desc: '파일 드롭, 스크린샷 붙여넣기, 라이브 스캔 전환을 즉시 수행.' },
        { title: '모바일에 최적', desc: '휴대폰/작은 화면을 위한 UI와 카메라 흐름 최적화.' },
      ],
    },
    intro: {
      title: '온라인 QR & 바코드 스캐너',
      body: '앱 설치 없이 브라우저에서 QR 코드, UPC, EAN 등을 바로 디코딩하세요.',
    },
    howTo: {
      title: '스캔 방법',
      methods: [
        {
          title: '방법 1: 업로드',
          steps: ['이미지 업로드 클릭', 'QR/바코드 선택', '즉시 결과 확인'],
        },
        {
          title: '방법 2: 카메라',
          steps: ['카메라 탭 열기', '권한 허용', 'QR/바코드에 맞추기'],
        },
      ],
    },
    features: {
      title: '이 스캐너를 사용해야 하는 이유',
      items: [
        { title: '로컬 기록', desc: '최근 스캔은 기기에만 저장되어 다시 복사/열기 쉽습니다.' },
        { title: '오프라인 이미지 디코딩', desc: '연결이 끊겨도 이미지 업로드/붙여넣기로 디코딩 가능합니다.' },
        { title: '빠른 액션', desc: '간단한 컨트롤로 결과를 즉시 복사/열기/삭제할 수 있습니다.' },
      ],
    },
    useCases: {
      title: '대표 사용 사례',
      items: [
        { title: '리테일 & 쇼핑', desc: '상품 URL, 쿠폰, 안내를 확인합니다.' },
        { title: '재고 팀', desc: '바코드를 확인하고 재고 업데이트를 관리합니다.' },
        { title: '일상 사용자', desc: '메뉴, Wi‑Fi 링크, 연락처 카드를 빠르게 엽니다.' },
      ],
    },
    faq: {
      title: '스캐너 FAQ',
      items: [
        { q: '바코드도 스캔할 수 있나요?', a: '네. QR 코드뿐 아니라 Code 128, UPC, EAN, ITF 등도 지원합니다.' },
        { q: '스캔 기록을 저장하나요?', a: '스캔 데이터는 브라우저를 떠나지 않으며 모두 기기에만 저장됩니다.' },
        { q: '스크린샷을 붙여넣을 수 있나요?', a: '네. Ctrl+V (Cmd+V)로 클립보드에서 붙여넣기 하세요.' },
        { q: '오프라인에서도 되나요?', a: '이미지 업로드는 오프라인에서도 동작합니다. 카메라 스캔은 권한과 지원 브라우저가 필요합니다.' },
      ],
    },
  },
  blog: {
    title: '인사이트 & 가이드',
    subtitle: 'QR 경험을 위한 베스트 프랙티스, 마케팅 아이디어, 제품 업데이트.',
    readMore: '글 읽기',
    back: '블로그로 돌아가기',
    notFound: '게시글을 찾을 수 없습니다',
  },
  common: {
    footer: '마케터, 디자이너, 팀을 위한 강력한 QR 생성 스위트.',
    privacy: '개인정보',
    terms: '약관',
    contact: '문의',
    scanToOpen: '모바일에서 열려면 스캔',
    help: '도움말',
    free: '무료',
    product: '제품',
    resources: '리소스',
    company: '회사',
    api: 'API (준비 중)',
    systemStatus: '시스템 정상',
    footerDesc:
      '가장 진보된 QR 코드 생성기 및 스캐너. 빠르고 프라이버시 중심이며 개인/상업적 용도로 영구 무료입니다.',
  },
};

